import React, { useEffect } from 'react';

import { useMutation } from '../hooks/graph';
const controller = new AbortController();

function MeConnectorHookDelete({ hook, getHookUrl, onSuccess }) {
	const [ hookDelete ] = useMutation('hookDelete', controller);

	const onSubmit = () => {
		hookDelete({
			id: hook.id,
		}).then(() => {
			onSuccess(); // refetch and more
		}).catch(() => {
			// obsoleted / setError('submit', {message: 'Error: ' + err.message}); // temporal message
		});
	};

	useEffect(() => () => controller.abort(), []); // abort on unmount

	return (
		<div className="modal" id="connectorHookDeleteModal" tabIndex="-1" aria-labelledby="connectorHookDeleteModalLabel">
			<div className="modal-dialog">
				{
					hook && (
						<div className="modal-content">

							<div className="modal-header">
								<h5 className="modal-title" id="connectorHookDeleteModalLabel">Confirmation</h5>
								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
							</div>

							<div className="modal-body">
								{/* TODO the "calledAt" attribute been dropped. use the actions to get last call timestamp */}
								<p>You are about to remove a webhook &quot;{hook.name || getHookUrl(hook.shortKey)}&quot;{hook.calledAt ? '(last triggered at ' + new Date(Math.round(hook.calledAt / 1000) * 1000).toLocaleString() + ')' : ''}.</p>

								<p>Removing a webhook means that all future requests to its URL will fail and won&apos;t execute any orders.
								You won&apos;t be able to restore your webhook, but you can create a new one.</p>

								<p>Are you sure you want to proceed?</p>
							</div>

							<div className="modal-footer">
								<button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
								<button type="button" className="btn btn-danger" onClick={onSubmit} data-bs-dismiss="modal">Confirm</button>
							</div>

						</div>
					)
				}
			</div>
		</div>
	);
}

export default MeConnectorHookDelete;
